import React from 'react';
import { connect } from 'react-redux';
import { Notification, useLogin, useNotify, userLogin } from 'react-admin';
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import * as yup from 'yup';
import { useFormik } from 'formik';
import "./textField.css";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(3)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    }
}));

const passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

const formValidationSchema = yup.object({
    email: yup
        .string()
        .email('Inserisci un\'email valida')
        .required('Email richiesta'),
    password: yup
        .string()
        .required('Password richiesta')
        .min(6, 'La password deve essere lunga almeno 6 caratteri'),
});

const Login = () => {
    const login = useLogin();
    const notify = useNotify();
    const submit = () => {
        const data = { username: formik.values.email, password: formik.values.password }
        login(data)
            .catch(() => notify('Invalid email or password'));
    };

    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },

        validationSchema: formValidationSchema,
        onSubmit: () => {
            submit();
        },

    });

    return (
        <div>
        <form onSubmit={formik.handleSubmit} >
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div>
                    <Container className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Login
                        </Typography>
                        <Container className={classes.form}>
                            <Notification />
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        className='textField'
                                        variant="outlined"
                                        required
                                        fullWidth
                                        type="text"
                                        id="email"
                                        label="Email"
                                        name="email"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.email}
                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className='textField'
                                        variant="outlined"
                                        required
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                        id="password"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.password}
                                        error={formik.touched.password && Boolean(formik.errors.password)}
                                        helperText={formik.touched.password && formik.errors.password}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                            >
                                Login
                            </Button>
                            <Grid container>
                                <Grid item xs>
                                    <Link href="#/service/forgot-password" variant="body2">
                                        Password dimenticata?
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Link href="#/register" variant="body2">
                                        Non hai un account? Registrati
                                    </Link>
                                </Grid>
                            </Grid>
                        </Container>
                    </Container>
                </div>
            </Container>
        </form>
        </div>
    );

};

export default connect(undefined, { userLogin })(Login);